import { yupResolver } from '@hookform/resolvers/yup';
import { useI18n } from '@i18n';
import LoadingButton from '@mui/lab/LoadingButton';
import { Button, Grid } from '@mui/material';
import { emission_factor_type_enum } from '@predium/enums';
import { useForm } from 'react-hook-form';
import { object, string } from 'yup';
import { PTypography } from '@/components/atoms/Typography/PTypography';
import { FormProvider, RHFTextField } from '@/components/hook-form';
import PreDialog, { PreDialogBody } from '@/components/presentations/PreDialog/PreDialog';
import usePosthogTracking from '@/hooks/usePosthogTracking';
import { PortfolioFormValuesProps } from '@/sections/Org/Portfolio/PortfolioCreateDialog';

export function NationalLawPortfolioForm({
  open,
  onClose,
  onPortfolioCreate,
  portfolios,
  loading,
  createMutateFunction,
}: any) {
  const { t } = useI18n();
  const { trackEvent } = usePosthogTracking();

  const NewPortfolioSchema = object().shape({
    name: string()
      .required(t('General_PortfolioNameIsRequired'))
      .notOneOf(
        portfolios.map((p: any) => p.name),
        t('General_PortfolioAlreadyExists'),
      ),
  });

  const defaultValues = {
    name: '',
  };

  const methods = useForm<PortfolioFormValuesProps>({
    resolver: yupResolver(NewPortfolioSchema),
    defaultValues,
    mode: 'onChange',
  });

  const { handleSubmit, reset } = methods;

  const onSubmit = async (data: PortfolioFormValuesProps) => {
    await createMutateFunction(
      {
        variables: {
          name: data.name,
        },
      },
      {
        onCompleted: () => {
          trackEvent('PORTFOLIO_CREATED', {
            emissionFactorType: emission_factor_type_enum.NATIONAL_ENERGY_LAW,
          });
        },
      },
    );
    onClose();
    reset();
    onPortfolioCreate?.();
  };

  return (
    <PreDialog open={open} onClose={onClose} fullWidth type="definedByChildren">
      <FormProvider
        methods={methods}
        onSubmit={(event) => {
          event.stopPropagation();
          event.preventDefault();
          handleSubmit(onSubmit)();
        }}
      >
        <PreDialogBody
          dialogtitle={t('General_CreateNewPortfolio')}
          content={
            <Grid container>
              <PTypography variant="body1" align={'justify'} sx={{ mb: 3 }}>
                {t('PortfolioCreateDialog_Description')}
              </PTypography>
              <Grid item xs={12}>
                <RHFTextField name="name" label={t('General_EnterName')} />
              </Grid>
            </Grid>
          }
          actions={
            <>
              <Button variant="outlined" onClick={onClose}>
                {t('General_Cancel')}
              </Button>
              <LoadingButton type="submit" variant="contained" loading={loading}>
                {t('General_Create')}
              </LoadingButton>
            </>
          }
        ></PreDialogBody>
      </FormProvider>
    </PreDialog>
  );
}
